import { ROUTES } from '@/helpers'

export default {
  created() {
    this.ROUTES = ROUTES
  },
}
